import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@leapsight/portal",2);
